var yuyueFirstObj = {
	'': 'web寒假班报名',
	'?jtppzq': 'web寒假班报名（百品）',
	'?360jtppzq': 'web寒假班报名（360）',
	'?tg': 'web寒假班报名（推广）',
}

var yuyueSecondObj = {
	'': 'web寒假班资料',
	'?jtppzq': 'web寒假班资料（百品）',
	'?360jtppzq': 'web寒假班资料（360）',
	'?tg': 'web寒假班资料（推广）',
}

var yuyueForthObj = {
	'': 'web寒假班浮窗',
	'?jtppzq': 'web寒假班浮窗（百品）',
	'?360jtppzq': 'web寒假班浮窗（360）',
	'?tg': 'web寒假班浮窗（推广）',
}

var lqQuery = window.location.search
new Reservation('#form1', {
	siteId: 3, // 站点ID
	contentName: yuyueFirstObj[lqQuery], // 预约名称
})

new Reservation('#form2', {
	siteId: 3, // 站点ID
	contentName: yuyueSecondObj[lqQuery], // 预约名称
})

new Reservation('#form3', {
	siteId: 3, // 站点ID
	contentName: yuyueForthObj[lqQuery], // 预约名称
})

setTimeout(function () {
	$('.new-toast').fadeIn()
}, 10000)
$('.new-guanbi').click(function () {
	$('.new-toast').fadeOut()
})
new Bselector({
	showSelected: '#cityTxt1',
	inputSelected: '#inputCity01',
	options: [
		{
			text: '北京市',
		},
		{
			text: '天津市',
		},
		{
			text: '上海市',
		},
		{
			text: '重庆市',
		},
		{
			text: '河北省',
		},
		{
			text: '河南省',
		},
		{
			text: '广东省',
		},
		{
			text: '辽宁省',
		},
		{
			text: '湖南省',
		},
		{
			text: '四川省',
		},
		{
			text: '安徽省',
		},
		{
			text: '山东省',
		},
		{
			text: '江苏省',
		},
		{
			text: '浙江省',
		},
		{
			text: '湖北省',
		},
		{
			text: '山西省',
		},
		{
			text: '陕西省',
		},
		{
			text: '福建省',
		},
		{
			text: '江西省',
		},
		{
			text: '广西省',
		},
		{
			text: '甘肃省',
		},
		{
			text: '黑龙江省',
		},
		{
			text: '内蒙古',
		},
		{
			text: '吉林省',
		},
		{
			text: '新疆维吾尔',
		},
		{
			text: '贵州省',
		},
		{
			text: '云南省',
		},
		{
			text: '青海省',
		},
		{
			text: '西藏',
		},
		{
			text: '宁夏回族',
		},
		{
			text: '海南省',
		},
	],
}) // 点击报名

new Bselector({
	showSelected: '#cityTxt2',
	inputSelected: '#inputCity02',
	options: [
		{
			text: '北京市',
		},
		{
			text: '天津市',
		},
		{
			text: '上海市',
		},
		{
			text: '重庆市',
		},
		{
			text: '河北省',
		},
		{
			text: '河南省',
		},
		{
			text: '广东省',
		},
		{
			text: '辽宁省',
		},
		{
			text: '湖南省',
		},
		{
			text: '四川省',
		},
		{
			text: '安徽省',
		},
		{
			text: '山东省',
		},
		{
			text: '江苏省',
		},
		{
			text: '浙江省',
		},
		{
			text: '湖北省',
		},
		{
			text: '山西省',
		},
		{
			text: '陕西省',
		},
		{
			text: '福建省',
		},
		{
			text: '江西省',
		},
		{
			text: '广西省',
		},
		{
			text: '甘肃省',
		},
		{
			text: '黑龙江省',
		},
		{
			text: '内蒙古',
		},
		{
			text: '吉林省',
		},
		{
			text: '新疆维吾尔',
		},
		{
			text: '贵州省',
		},
		{
			text: '云南省',
		},
		{
			text: '青海省',
		},
		{
			text: '西藏',
		},
		{
			text: '宁夏回族',
		},
		{
			text: '海南省',
		},
	],
}) // 领取资料

new Swiper('.school_swiper', {
	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
	},
	loop: true,
	slidesPerView: 'auto',
	pagination: {
		el: '.school_pagination',
		clickable: true,
	},
})

new Swiper('.reasonTwo_container', {
	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
	},
	loop: true,
	slidesPerView: 'auto',
	pagination: {
		el: '.reasonTwo_pagination',
		clickable: true,
	},
})

new Swiper('.book_swiper', {
	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
	},
	loop: true,
	slidesPerView: 'auto',
	pagination: {
		el: '.book_pagination',
		clickable: true,
	},
})

new Swiper('.keep_container', {
	loop: true,
	autoplay: {
		delay: 3000,
	},
	speed: 1000,
	navigation: {
		nextEl: '.keep_next',
		prevEl: '.keep_prev',
	},
})

$('.choose_btn_list').click(function () {
	var top1 = $('.box6').offset().top
	$('html,body').animate({
		scrollTop: top1,
	})
})

new Bselector({
	showSelected: '#courseTxt',
	inputSelected: '.hiddenCourse',
	options: [
		{
			text: '雅思',
		},
		{
			text: '托福',
		},
		{
			text: 'SAT',
		},
	],
})

new Bselector({
	showSelected: '#cityTxt',
	inputSelected: '.hiddenCity',
	options: [
		{
			text: '北京市',
		},
		{
			text: '天津市',
		},
		{
			text: '上海市',
		},
		{
			text: '重庆市',
		},
		{
			text: '河北省',
		},
		{
			text: '河南省',
		},
		{
			text: '广东省',
		},
		{
			text: '辽宁省',
		},
		{
			text: '湖南省',
		},
		{
			text: '四川省',
		},
		{
			text: '安徽省',
		},
		{
			text: '山东省',
		},
		{
			text: '江苏省',
		},
		{
			text: '浙江省',
		},
		{
			text: '湖北省',
		},
		{
			text: '山西省',
		},
		{
			text: '陕西省',
		},
		{
			text: '福建省',
		},
		{
			text: '江西省',
		},
		{
			text: '广西省',
		},
		{
			text: '甘肃省',
		},
		{
			text: '黑龙江省',
		},
		{
			text: '内蒙古',
		},
		{
			text: '吉林省',
		},
		{
			text: '新疆维吾尔',
		},
		{
			text: '贵州省',
		},
		{
			text: '云南省',
		},
		{
			text: '青海省',
		},
		{
			text: '西藏',
		},
		{
			text: '宁夏回族',
		},
		{
			text: '海南省',
		},
	],
}) // 悬浮框
